

























import Vue from "vue";
import { Prop } from "vue-property-decorator";
import Component from "vue-class-component";

@Component
export default class ElCircle extends Vue {
	@Prop({ type: Number, default: 0 }) percent!: number;
	@Prop({ type: Number, default: 126 }) size!: number;
	@Prop({ type: Number, default: 6 }) strokeWidth!: number;
	@Prop({ type: String, default: "#2d8cf0" }) strokeColor!: string;
	@Prop({
		type: String,
		default: "round",
		validator(value) {
			return !!["square", "round"].find(item => item === value);
		}
	})
	strokeLinecap!: string;
	@Prop({ type: Number, default: 5 }) trailWidth!: number;
	@Prop({ type: String, default: "#eaeef2" }) trailColor!: string;
	@Prop({ type: Boolean, default: false }) dashboard!: boolean;

	get circleSize() {
		return {
			width: `${this.size}px`,
			height: `${this.size}px`
		};
	}
	get computedStrokeWidth() {
		return this.percent === 0 && this.dashboard ? 0 : this.strokeWidth;
	}
	get radius() {
		return 50 - this.strokeWidth / 2;
	}
	get pathString() {
		if (this.dashboard) {
			return `M 50,50 m 0,${this.radius}
                    a ${this.radius},${this.radius} 0 1 1 0,-${2 * this.radius}
                    a ${this.radius},${this.radius} 0 1 1 0,${2 * this.radius}`;
		} else {
			return `M 50,50 m 0,-${this.radius}
                    a ${this.radius},${this.radius} 0 1 1 0,${2 * this.radius}
                    a ${this.radius},${this.radius} 0 1 1 0,-${2 *
				this.radius}`;
		}
	}
	get len() {
		return Math.PI * 2 * this.radius;
	}
	get trailStyle() {
		let style = {};
		if (this.dashboard) {
			style = {
				"stroke-dasharray": `${this.len - 75}px ${this.len}px`,
				"stroke-dashoffset": `-${75 / 2}px`,
				transition:
					"stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s"
			};
		}
		return style;
	}
	get pathStyle() {
		let style = {};
		if (this.dashboard) {
			style = {
				"stroke-dasharray": `${(this.percent / 100) *
					(this.len - 75)}px ${this.len}px`,
				"stroke-dashoffset": `-${75 / 2}px`,
				transition:
					"stroke-dashoffset .3s ease 0s, stroke-dasharray .6s ease 0s, stroke .6s, stroke-width .06s ease .6s"
			};
		} else {
			style = {
				"stroke-dasharray": `${this.len}px ${this.len}px`,
				"stroke-dashoffset": `${((100 - this.percent) / 100) *
					this.len}px`,
				transition: "stroke-dashoffset 0.6s ease 0s, stroke 0.6s ease"
			};
		}
		return style;
	}
	get wrapClasses() {
		return `circle`;
	}
	get innerClasses() {
		return `circle-inner`;
	}
}
